import 'core-js/es/promise'; // For IE 11 support
import React from 'react';
import ReactDOM from 'react-dom';
import {AppContainer} from 'react-hot-loader';
import getCurrentScriptPath from '@homeaway/current-script-path';
import {ApolloClient} from 'apollo-client';
import {createHttpLink} from 'apollo-link-http';
import {
    InMemoryCache,
    IntrospectionFragmentMatcher,
} from 'apollo-cache-inmemory';
import {createPersistedQueryLink} from 'apollo-link-persisted-queries';

import './index.less';
import Root from './Root';

/**
 * Main client-side entry point. This is not used during
 * server-side rendering, only after the javascript bundle
 * has been loaded into the browser.
 */

// Let webpack know where to load files from in production envs.
// This is primarily for code-splitting scenarios and for images.
if (!module.hot) {
    __webpack_public_path__ = getCurrentScriptPath(); // eslint-disable-line
}

const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData: window.fragmentTypes,
});
const cache = new InMemoryCache({fragmentMatcher});
// Create GraphQL client
const client = new ApolloClient({
    link: createPersistedQueryLink({useGETForHashedQueries: true}).concat(
        createHttpLink({uri: '/ch/graphql'}),
    ),
    // Initialize cache with server side rendered data that was embedded in the page
    cache: cache.restore(window.__APOLLO_STATE__),
});

ReactDOM.hydrate(
    <AppContainer>
        <Root
            client={client}
            homeRoute={window.homeRoute}
            footerData={window.footerData}
            redirects={window.redirects}
            systemData={window.systemData}
        />
    </AppContainer>,
    document.getElementById('root'),
);

// Hot module replacement in development env only
if (module.hot) {
    module.hot.accept('./Root', () => {
        const RootRequired = require('./Root').default;
        ReactDOM.unmountComponentAtNode(document.getElementById('root'));
        ReactDOM.hydrate(
            <AppContainer>
                <RootRequired
                    client={client}
                    homeRoute={window.homeRoute}
                    footerData={window.footerData}
                    redirects={window.redirects}
                    systemData={window.systemData}
                />
            </AppContainer>,
            document.getElementById('root'),
        );
        console.log(`[HMR] Rendered at ${new Date().toLocaleTimeString()}`); // eslint-disable-line
    });
}
